// GraphQL
import { client } from '../../../../../../gql/client';
import {
  GET_CAPITOL_BY_ID,
  GET_CLASSIFICATION_BY_ID_OR_ROID,
  GET_SUB_CAPITOL_BY_ID,
} from '../../../../../../gql/queries/orders/predefinedData';
import {
  GET_CONCESSION_BY_ID,
  GET_ROAD_BY_ID,
} from '../../../../../../gql/queries/geoPositions/roads';
import { GET_TEAM_BY_ID } from '../../../../../../gql/queries/users';

// Types
import { laneLabel, trackLabel } from '../../../../../../utils/catalogLabels';

export const passData = async (formData: FormData) => {
  const operator = formData.get('operator');
  const registerInitDate = formData.get('registerInitDate');
  const sendStatus = formData.get('sendStatus');
  const concessionId = formData.get('concession');
  const roadId = formData.get('road');
  const classificationId = formData.get('classification');
  const capitolId = formData.get('capitol');
  const subCapitolId = formData.get('subCapitol');

  const teamIdRaw = formData.get('teamRelationships') || formData.get('team') || formData.get('teams');
  const teamIdStr = typeof teamIdRaw === 'string' ? teamIdRaw : '';

  const [
    {
      data: { concession },
    },
    {
      data: { road },
    },
    {
      data: { classification },
    },
    {
      data: { capitol },
    },
    {
      data: { subCapitol },
    },
  ] = await Promise.all([
    client.query({
      query: GET_CONCESSION_BY_ID,
      variables: {
        id: concessionId,
      },
    }),
    client.query({
      query: GET_ROAD_BY_ID,
      variables: {
        id: roadId,
      },
    }),
    client.query({
      query: GET_CLASSIFICATION_BY_ID_OR_ROID,
      variables: {
        id: classificationId,
      },
    }),
    client.query({
      query: GET_CAPITOL_BY_ID,
      variables: {
        id: capitolId,
      },
    }),
    client.query({
      query: GET_SUB_CAPITOL_BY_ID,
      variables: {
        id: subCapitolId,
      },
    }),
  ]);

  let teamName = '';
  if (teamIdStr) {
    try {
      const { data: { team } } = await client.query({
        query: GET_TEAM_BY_ID,
        variables: { id: teamIdStr },
      });
      teamName = team?.name || '';
    } catch {}
  }

  const city = formData.get('city');
  const pkInitRoad = formData.get('pkInitRoad');
  const pkEndRoad = formData.get('pkEndRoad');
  const trackValue = formData.get('track');
  const direction = formData.get('direction');
  const margin = formData.get('margin');
  const laneValue = formData.get('lane');
  const pkInit = formData.get('pkInit');
  const pkEnd = formData.get('pkEnd');
  const description = formData.get('description');
  const notes = formData.get('notes');
  const campaign = formData.get('campaign');
  const isCampaignActive = formData.get('isCampaignActive');

  return {
    operator,
    registerInitDate,
    sendStatus,
    concession: concession?.name,
    city,
    pkInitRoad: pkInitRoad?.toString(),
    pkEndRoad: pkEndRoad?.toString(),
    road: road?.name,
    track: trackLabel(trackValue as string | null),
    roadDirections: road.directions,
    direction,
    margin,
    lane: laneLabel(laneValue as string | null),
    pkInit,
    pkEnd,
    description,
    notes,
    campaign: isCampaignActive === 'true' ? campaign : null,
    classification: classification?.name,
    capitol: capitol?.name,
    subCapitol: subCapitol?.name,
    team: teamName,
  };
};
